var errorMap = {
    "auth/email-already-in-use"   : "Email already in use",
    "auth/wrong-password" : "Incorrect credentials",
    "auth/weak-password" : "Password must be 6 or more characters long",
    "auth/user-not-found" : "Please enter a valid email address or signup",
    "auth/unknown" : "Please try again later"
}

export default errorMap;